module.exports = __webpack_public_path__ + "static/project-12a-27365830aa6bb2447e6dfbd2d2b85761.png";